import { persistStateTypes } from 'a/reducers/persistStateReducer';
import { GAME_ID, REDUX_ACTIONS, ONBOARDING_TYPES, ONBOARDING_STEPS, SCREENS } from '../../data/constants';

const initialState = {
  isInOnboarding: false,
  onboardingType: ONBOARDING_TYPES.NONE,
  hasSeenOnboarding: false,

  currentOnboardingStep: ONBOARDING_STEPS.WAITING_FOR_USER_TO_ZOOM_IN_ON_MAP,

  isDisablingTransitionToStandardItem: false,
  isDisablingNextButtonOnNotebook: false,
  isDisablingNextButtonOnInferencePanel: false,
  isDisablingInferenceSelection: false,
  isDisablingEvidenceSelection: false,
  isDisablingDoneButton: false,
  isDisablingTransitionToMapScreen: false,
  isDisablingCameraButton: false,
  isDisablingCompletionOfPhotoAnimation: false,

  isAnimatingInferenceTypeIcon: false,
  isAnimatingNextButtonOnInferencePanel: false,
  isAnimatingBadgeCorrectInfereceChoice: false,
  isHighlightingCorrectEvidence: false,
  isAnimatingBadge: false,
};

const onboardingReducer = (state = initialState, action) => {
  const { type, payload, gameId } = action;
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    default:
      return state;

    case persistStateTypes.REQUESTRESPONSE_GAMESTATE: {
      const { stateData } = action;
      const { GameData } = stateData[GAME_ID];
      if (GameData !== null && GameData !== undefined) {
        return {
          ...state,
          hasSeenOnboarding: GameData.hasSeenOnboarding,
        };
      }
      return state;
    }

    case REDUX_ACTIONS.SET_LEVEL_INDEX: {
      const isInOnboarding = (payload.onboardingType !== ONBOARDING_TYPES.NONE);
      return {
        ...initialState,
        isInOnboarding,
        onboardingType: payload.onboardingType,
        hasSeenOnboarding: state.hasSeenOnboarding,
        currentOnboardingStep: ONBOARDING_STEPS.WAITING_FOR_USER_TO_ZOOM_IN_ON_MAP,
        isDisablingTransitionToStandardItem: isInOnboarding,
        isDisablingNextButtonOnNotebook: isInOnboarding,
        isDisablingNextButtonOnInferencePanel: isInOnboarding,
        isDisablingTransitionToMapScreen: isInOnboarding,
        isDisablingCameraButton: isInOnboarding,
        isDisablingCompletionOfPhotoAnimation: isInOnboarding,
      };
    }

    case REDUX_ACTIONS.END_ONBOARDING:
      return {
        ...state,
        isInOnboarding: false,
        hasSeenOnboarding: true,

        isDisablingTransitionToStandardItem: false,
        isDisablingNextButtonOnNotebook: false,
        isDisablingNextButtonOnInferencePanel: false,
        isDisablingInferenceSelection: false,
        isDisablingEvidenceSelection: false,
        isDisablingDoneButton: false,
        isDisablingTransitionToMapScreen: false,
        isDisablingCameraButton: false,
        isDisablingCompletionOfPhotoAnimation: false,

        isAnimatingInferenceTypeIcon: false,
        isAnimatingNextButtonOnInferencePanel: false,
        isAnimatingBadgeCorrectInfereceChoice: false,
        isHighlightingCorrectEvidence: false,
        isAnimatingBadge: false,
      };

    // #region actions to disable / animate components
    case REDUX_ACTIONS.SET_IS_DISABLING_TRANSITION_TO_STANDARD_ITEM:
      return {
        ...state,
        isDisablingTransitionToStandardItem: payload,
      };

    case REDUX_ACTIONS.SET_IS_DISABLING_NEXT_BUTTON_ON_NOTEBOOK:
      return {
        ...state,
        isDisablingNextButtonOnNotebook: payload,
      };

    case REDUX_ACTIONS.SET_IS_DISABLING_NEXT_BUTTON_ON_INFERENCE_PANEL:
      return {
        ...state,
        isDisablingNextButtonOnInferencePanel: payload,
      };

    case REDUX_ACTIONS.SET_IS_DISABLING_INFERENCE_SELECTION:
      return {
        ...state,
        isDisablingInferenceSelection: payload,
      };

    case REDUX_ACTIONS.SET_IS_DISABLING_EVIDENCE_SELECTION:
      return {
        ...state,
        isDisablingEvidenceSelection: payload,
      };

    case REDUX_ACTIONS.SET_IS_DISABLING_DONE_BUTTON:
      return {
        ...state,
        isDisablingDoneButton: payload,
      };

    case REDUX_ACTIONS.SET_IS_DISABLING_TRANSITION_TO_MAP_SCREEN:
      return {
        ...state,
        isDisablingTransitionToMapScreen: payload,
      };

    case REDUX_ACTIONS.SET_IS_DISABLING_CAMERA_BUTTON:
      return {
        ...state,
        isDisablingCameraButton: payload,
      };

    case REDUX_ACTIONS.SET_IS_DISABLING_COMPLETION_OF_PHOTO_ANIMATION:
      return {
        ...state,
        isDisablingCompletionOfPhotoAnimation: payload,
      };

    case REDUX_ACTIONS.SET_IS_ANIMATING_INFERENCE_TYPE_ICON:
      return {
        ...state,
        isAnimatingInferenceTypeIcon: payload,
      };

    case REDUX_ACTIONS.SET_IS_ANIMATING_NEXT_BUTTON_ON_INFERENCE_PANEL:
      return {
        ...state,
        isAnimatingNextButtonOnInferencePanel: payload,
      };

    case REDUX_ACTIONS.SET_IS_ANIMATING_BADGE_CORRECT_INFERECE_CHOICE:
      return {
        ...state,
        isAnimatingBadgeCorrectInfereceChoice: payload,
      };

    case REDUX_ACTIONS.SET_IS_HIGHLIGHTING_CORRECT_EVIDENCE:
      return {
        ...state,
        isHighlightingCorrectEvidence: payload,
      };

    case REDUX_ACTIONS.SET_IS_ANIMATING_BADGE:
      return {
        ...state,
        isAnimatingBadge: payload,
      };
      // #endregion

    // #region actions for managing the current onboarding step
    case REDUX_ACTIONS.SET_IS_MAP_ZOOMED: {
      if (payload === true) {
        return transitionCurrentOnboardingStep(state, {
          from: ONBOARDING_STEPS.WAITING_FOR_USER_TO_ZOOM_IN_ON_MAP,
          to: ONBOARDING_STEPS.EXPLANATION_BEFORE_STANDARD_ITEM,
        });
      }
      return state;
    }

    case REDUX_ACTIONS.CHANGE_SCREEN: {
      if (payload === SCREENS.STANDARD_VIEW) {
        return transitionCurrentOnboardingStep(state, {
          from: ONBOARDING_STEPS.EXPLANATION_BEFORE_STANDARD_ITEM,
          to: ONBOARDING_STEPS.EXPLANATION_AT_START_OF_STANDARD_ITEM,
        });
      }

      return state;
    }

    case REDUX_ACTIONS.ON_REVEAL_INFERENCE_CHOICES:
      return transitionCurrentOnboardingStep(state, {
        from: ONBOARDING_STEPS.EXPLANATION_AT_START_OF_STANDARD_ITEM,
        to: ONBOARDING_STEPS.PROMPT_USER_TO_CHOOSE_INFERENCE,
      });

    case REDUX_ACTIONS.SET_SELECTED_INFERENCE_INDEX:
      return {
        ...transitionCurrentOnboardingStep(state, {
          from: ONBOARDING_STEPS.PROMPT_USER_TO_CHOOSE_INFERENCE,
          to: ONBOARDING_STEPS.PROMPT_USER_TO_CHOOSE_EVIDENCE,
        }),
        isDisablingInferenceSelection: true,
      };

    case REDUX_ACTIONS.TOGGLE_EVIDENCE_SELECTION:
      return {
        ...transitionCurrentOnboardingStep(state, {
          from: ONBOARDING_STEPS.PROMPT_USER_TO_CHOOSE_EVIDENCE,
          to: ONBOARDING_STEPS.PROMPT_USER_TO_PRESS_DONE,
        }),
        isDisablingEvidenceSelection: true,
      };

    case REDUX_ACTIONS.MARK_ITEM_AS_COMPLETE:
      return transitionCurrentOnboardingStep(state, {
        from: ONBOARDING_STEPS.PROMPT_USER_TO_PRESS_DONE,
        to: ONBOARDING_STEPS.EXPLANATION_AT_START_OF_PHOTO_MOMENT,
      });

      // NOTE - transition from EXPLANATION_AT_START_OF_PHOTO_MOMENT to
      // explanation_at_start_of_photo moment is handled above in the change_screen action.

    case REDUX_ACTIONS.ON_MIDDLE_OF_PHOTO_ANIMATION:
      return transitionCurrentOnboardingStep(state, {
        from: ONBOARDING_STEPS.EXPLANATION_AT_START_OF_PHOTO_MOMENT,
        to: ONBOARDING_STEPS.EXPLANATION_IN_MIDDLE_OF_PHOTO_MOMENT,
      });

    case REDUX_ACTIONS.ON_END_MIDDLE_OF_PHOTO_ANIMATION:
      return transitionCurrentOnboardingStep(state, {
        from: ONBOARDING_STEPS.EXPLANATION_IN_MIDDLE_OF_PHOTO_MOMENT,
        to: ONBOARDING_STEPS.COMPLETE_ONBOARDING,
      });
    // #endregion
  }
};

export default onboardingReducer;

function transitionCurrentOnboardingStep(state, fromTo) {
  const { to: destinationStep, from: sourceStep } = fromTo;

  if (
    state.currentOnboardingStep === sourceStep
  ) {
    return {
      ...state,
      currentOnboardingStep: destinationStep,
    };
  }
  return state;
}
